export default __webpack_public_path__ + "da9712ec6135c500102f2b9dd7f902d1.woff";